var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"page-content",style:(_vm.contentStyles)},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"page-footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70277ac3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page.vue
// module id = null
// module chunks = 